define([
    "skylark-utils/scripter"
], function(scripter) {
    return scripter;
});
